import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';

export const SSOLoginButton: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <a href={process.env.REACT_APP_CP_SSO_URL}>
        <Button label={t('components:signIn:loginWithCustomerPortal')} />
      </a>
    </>
  );
};
